// const Image = require("./image")
import preview from "./components/elements/Preview"
import labeler from "./components/elements/Labeler"
const version = "1.1.4"
export const Preview = preview
export const Labeler = labeler
export const Version = version
export default {
  Version,
  Labeler,
  Preview
}
